var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterStyle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "-459 261 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#424D56",
    d: "M-426.6 284.4l-5.3-2.5c-.6-2.1-2-7-2.3-7.7-.4-1-2.7-2.2-4.2-2.5-1.4-.3-5.2-.8-9.7 1.4-4.7 2.2-6.4 6.5-5.3 13 0 .2.2.3.4.3l2.7.1s0 .1.1.1l.8.6c.3.3 1.9 2 2.4 2.3 0 0 2.9 2.1 5.1 2.2h.2c1.8 0 3.3-.8 4.1-1.3.1-.1.5-.3.9-.6 1.7-1.1 5.6-3.8 6.9-4.3 1.8-.7 2.9-.4 2.9-.4.2 0 .4-.1.4-.2.2-.3.1-.5-.1-.5zm-22.2-10.1c.3-.2.7-.4 1.1-.6 4.3-2 7.9-1.6 9.2-1.3 1.4.3 3.4 1.4 3.6 2v.1c.2.4 1.4 4.3 2.1 7.1h-.1c-3.5 0-10.6 2.2-11.2 2.5-.1.1-.6.2-1.2.4l-3.3.9c-.3-1.4-1.1-5.1-1.1-6.2.3-.9-.3-3.3.9-4.9zm22.2 15.9h-.2c-2.1-.3-3.7-1.1-4.8-2.5-.1-.1-.1-.2-.1-.3 0-.1.1-.2.2-.2 2.5-1.2 4-1.7 4.8-1.6 1.5.3 2.4 1.1 2.4 2.3 0 .7-.3 1.3-.8 1.7-.4.4-1 .6-1.5.6z"
  })));
}

export default SvgFilterStyle;